import React, { useState } from 'react';
import IconArrowRight from '../../assets/icons/arrow-right-icon.svg';
import IconArrowLeft from '../../assets/icons/arrow-left-icon.svg';
import './Sidenav.scss';
import { SidebarItem, Sidebar } from './Sidebar';

type IProp = {
  routes: SidebarItem[];
};

export function Sidenav({ routes }: IProp) {
  const [leftSidenavOpen, setLeftSidenavOpen] = useState(false);
  const toggleLeftSidenav = () => setLeftSidenavOpen(!leftSidenavOpen);

  return (
    <div
      className={`${'sidenav'} ${leftSidenavOpen ? 'menu-open' : 'menu-close'}`}
    >
      <div
        role='button'
        tabIndex={0}
        className={'caret'}
        aria-label='Toggle menu'
        onClick={toggleLeftSidenav}
        onKeyPress={toggleLeftSidenav}
      >
        {leftSidenavOpen ? (
          <IconArrowLeft className={'caretLeft'} />
        ) : (
          <IconArrowRight className={'caretLeft'} />
        )}
      </div>
      <Sidebar
        routes={routes}
        isOpened={leftSidenavOpen}
        onLinkClick={() => setLeftSidenavOpen(false)}
      />
    </div>
  );
}
